import { removeHiddenFunds, iClassFunds } from '../FundListFragment/util';

const validateTaxablePortfolioEditMode = (
  selectedFunds,
  editPortfolio,
  validTaxableCart,
  isValidTotal
) => {
  return (
    selectedFunds.length > 0 &&
    editPortfolio &&
    validTaxableCart &&
    isValidTotal
  );
};

const validateIRAPortfolioEditMode = (
  selectedFunds,
  editPortfolio,
  validCart,
  isValidTotal
) => {
  return selectedFunds.length > 0 && editPortfolio && validCart && isValidTotal;
};
const validatePortfolioEditMode = (
  selectedFunds,
  editPortfolio,
  validCart,
  validTaxableCart,
  taxableJointPortfolios,
  taxableIndividualPortfolios,
  isValidTotal
) => {
  if (taxableJointPortfolios || taxableIndividualPortfolios) {
    return validateTaxablePortfolioEditMode(
      selectedFunds,
      editPortfolio,
      validTaxableCart,
      isValidTotal
    );
  }
  return validateIRAPortfolioEditMode(
    selectedFunds,
    editPortfolio,
    validCart,
    isValidTotal
  );
};

export const shouldValidate = (
  selectedFunds,
  editPortfolio,
  validCart,
  validTaxableCart,
  taxableJointPortfolios,
  taxableIndividualPortfolios,
  isValidTotal
) => {
  if (editPortfolio) {
    return validatePortfolioEditMode(
      selectedFunds,
      editPortfolio,
      validCart,
      validTaxableCart,
      taxableJointPortfolios,
      taxableIndividualPortfolios,
      isValidTotal
    );
  }
  if (selectedFunds.length > 0) {
    return true;
  }
  return false;
};

export const formatFunds = (allMutualFunds, rewardsAvailable, totalAmount) => {
  const {
    closedFunds: closedFundsReward,
    iClassFunds: iClassFundsReward
  } = rewardsAvailable;

  const hasClosedFundsReward = newFund =>
    !newFund.openToNewInvestors &&
    newFund.openToSubsequentInvestments &&
    closedFundsReward;

  const hasIClassFundsReward = newFund => newFund.iClass && iClassFundsReward;

  const closedFundRulesApplied = allMutualFunds.map(fund => {
    const newFund = fund;

    if (!newFund.openToNewInvestors) newFund.isClosedFund = true;
    if (hasClosedFundsReward(newFund)) {
      newFund.openToNewInvestors = true;
      newFund.unlockedFund = true;
    }
    return newFund;
  });

  const iClassRulesApplied = removeHiddenFunds(
    iClassFunds(totalAmount, closedFundRulesApplied, iClassFundsReward)
  );

  const summitIClassRulesApplied = iClassRulesApplied.map(fund => {
    const newFund = fund;

    if (hasIClassFundsReward(newFund)) {
      newFund.unlockedFund = true;
    }
    return newFund;
  });

  const finalFormattedFunds = summitIClassRulesApplied;

  return finalFormattedFunds;
};
